import iReducer from 'renderer/Global/State/reducerInterface';
import { range } from 'lodash';
import Warehouse from 'renderer/Global/Attributes/Facilities/Warehouse/Warehouse';
import { Edit2 } from 'react-feather';
import './style.css';
import { useState } from 'react';

interface iFacilitiesItem extends iReducer {
  warehouse: Warehouse;
  index: number;
}

export default function FacilitiesItem({
  state,
  dispatch,
  warehouse,
  index,
}: iFacilitiesItem) {
  const [editWarehouseNickname, setEditWarehouseNickname] = useState(false);
  const [warehouseNickname, setWarehouseNickname] = useState(
    warehouse.getNickName()
  );

  const toggleWarehouseEdit = () => {
    setEditWarehouseNickname((editWarehouseNickname) => !editWarehouseNickname);
  };

  const inputNickname = (currentNickname: string) => {
    setWarehouseNickname(currentNickname);
  };

  const saveNickname = () => {
    if (warehouseNickname.length) {
      dispatch({
        attribute: 'warehouse',
        operation: 'updateWarehouseNickname',
        id: index,
        payload: warehouseNickname,
      });
      setEditWarehouseNickname(false);
    }
  };

  return (
    <>
      <hr />
      <div>
        {editWarehouseNickname ? (
          <>
            <input
              value={warehouseNickname}
              onChange={(e) => inputNickname(e.target.value)}
            ></input>
            <button onClick={() => saveNickname()}>Save</button>
          </>
        ) : (
          <>
            <b>{warehouse.getNickName()}</b>
            <Edit2
              className="editWarehouse"
              size={20}
              onClick={() => toggleWarehouseEdit()}
            />
          </>
        )}
      </div>
      {warehouse.getCapacity()})<div>Available Probes</div>
      {range(0, Object.keys(warehouse.probes).length).map((k) => (
        <div key={k}>
          <div>Probe: {warehouse.probes[k].amount}</div>
          <div>- Target Item: {warehouse.probes[k].targetItem.displayName}</div>
          <div>- Target Location: {warehouse.probes[k].targetLocation}</div>
          <div>- Size: {warehouse.probes[k].upgrades.size}</div>
          <div>- Storage: {warehouse.probes[k].upgrades.storage}</div>
          <div>- Shielding: {warehouse.probes[k].upgrades.shielding}</div>
          <div>
            - ExteriorColor: {warehouse.probes[k].upgrades.exteriorColor}
          </div>
        </div>
      ))}
    </>
  );
}
